export default __webpack_public_path__ + "static/media/robot.a47fb9ee.png";